import React from 'react'

import { Kicker, Title } from '../Typography'
import { titleStyling } from './ContactDetailsComponent.module.css'

const ContactDetailsComponent = ({
  extraContentClassName,
  extraTitleClassName,
  kicker,
  phone = false,
  renderContent,
  title,
}) => {
  return (
    <div>
      {kicker && (
        <Kicker extraClassName={extraContentClassName}>{kicker}</Kicker>
      )}
      {title && !phone && (
        <Title extraClassname={extraTitleClassName}>{title}</Title>
      )}
      {title && phone && (
        <a
          className={`${titleStyling} ${extraTitleClassName}`}
          href={`tel:${title}`}
        >
          {title}
        </a>
      )}
      {renderContent && (
        <Title
          extraClassname={extraTitleClassName}
          renderContent={renderContent}
        />
      )}
    </div>
  )
}

export default ContactDetailsComponent
